import { types } from 'mobx-state-tree';
import Price from './Price';
import ProductPriceInfo from './ProductPriceInfo';
import { ProductClassType } from '../types/ProductClass';
import ProductMatrix from './ProductMatrix';
import ProductMulti from './ProductMulti';

const ProductListProduct = types.model('ProductListProduct', {
  id: types.string,
  multiproduct_id: types.string,
  product_id: types.string,
  name: types.string,
  quantity: types.number,
  stock_unit: types.string,
  package_size: types.maybeNull(types.number),
  price_info: types.maybeNull(ProductPriceInfo),
  class: ProductClassType,
  collection: types.maybeNull(ProductMatrix),
  multi: types.maybeNull(ProductMulti),
  multiproduct_title: types.maybeNull(types.string),
  total_price: Price,
  link: types.string,
  image: types.maybeNull(types.string),
  availability_html: types.string,
  available_for_purchase: types.boolean,
  variations: types.array(types.maybeNull(types.string))
});

export default ProductListProduct;



// WEBPACK FOOTER //
// ./src/models/ProductListProduct.js